<template>
  <b-modal
    ref="modal-rrhh-employee-viatic-tracking"
    :title="$t('VIATIC TRACKING')"
    modal-class="modal-primary"
    hide-footer
    @hidden="$emit('hideModal')"
    size="lg"
    scrollable
  >
    <div class="mb-2 mt-1">
      <b-row>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>CODE</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="dataModal.code" disabled />
          </b-input-group>
          <!-- <h5>Code</h5>
            <p
              class="rounded text-primary border-primary font-medium-1 text-center py-1s"
            >
              {{ dataModal.code }}
            </p> -->
        </b-col>
        <b-col sm="6">
          <b-input-group class="mb-1">
            <template #prepend>
              <b-input-group-text class="prepend__width">
                <strong>NAME</strong>
              </b-input-group-text>
            </template>
            <b-form-input :value="dataModal.personal_name" disabled />
          </b-input-group>
        </b-col>
      </b-row>
    </div>
    <div class="table-responsive">
      <b-table
        small
        sticky-header="50vh"
        class="position-relative"
        table-class="text-nowrap"
        :items="items"
        :fields="showFields"
      >
        <template #cell(created_by)="data">
          <span> {{ data.value | capitalize }} </span> <br />
        </template>
        <template #cell(is_viatic)="data">
          <b-badge
            pill
            :variant="`light-${data.value == 'Apply' ? 'success' : 'danger'}`"
          >
            <span> {{ $t(data.value) }}</span>
          </b-badge>
        </template>
        <template #cell(created_at)="data">
          <span style="opacity: 0.5">
            {{ data.item.created_at | globalDate }}
          </span>
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import modalMixin from "@/mixins/modal";
import FieldsModal from "@/views/rrhh/views/employees/data/Fields-viatic-tracking.data.js";
/* Service */
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";

export default {
  mixins: [modalMixin],
  props: {
    dataModal: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      items: [],
      fields: FieldsModal,
    };
  },
  mounted() {
    this.toggleModal("modal-rrhh-employee-viatic-tracking");
  },
  async created() {
    await this.getViaticTracking();
  },
  computed: {
    showFields() {
      return this.fields.filter((item) => item.visible);
    },
  },
  methods: {
    validateFields() {
      const status = this.fields[1];
      if (this.dataModal.homework_status_id != null) {
        status.visible = false;
      } else {
        status.visible = true;
      }
    },
    async getViaticTracking() {
      try {
        this.addPreloader();
        const params = {
          attendance_id: this.dataModal.attendance_id,
        };
        const { data } = await EmployeeService.getViaticTracking(params);
        this.items = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },

    homeworkStatusVariant(homework_status_id) {
      if (homework_status_id === 4) return "warning";
      if (homework_status_id === 3) return "danger";
      if (homework_status_id === 1 || homework_status_id === 2)
        return "success";
      if (homework_status_id === "inactive") return "secondary";
      return "primary";
    },
  },
};
</script>

<style scoped>
.py-1s {
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>